import { put, takeEvery } from 'redux-saga/effects';
import {
  FETCH_ERROR,
  showNotification,
} from 'react-admin';

function* fetchError({ error }) {
  // eslint-disable-next-line no-console
  console.error(error.message || error);
  yield put(showNotification(error.message, 'warning'));
}

export default function* fetchErrorSaga() {
  yield takeEvery(FETCH_ERROR, fetchError);
}



// WEBPACK FOOTER //
// ./src/fetchErrorSaga.js